// extracted by mini-css-extract-plugin
module.exports =  {"root":"D1AEY5KRq7z0VPKQ38EG"};